/**
 * GH#1082 — el dueño que elige «agente» en el alta queda como `AGENCY_ADMIN` con `profile.oficio =
 * 'AGENCY_AGENT_USER'` (backend: auth.service.ts rolDelDuenoEnOnboarding). El front decidía todo por `role`, así que
 * ese dueño no veía el módulo /agente/*. Este helper es la ÚNICA definición de «dueño-agente» y de los roles que
 * puede ejercer; un `AGENCY_ADMIN` sin oficio de agente (p. ej. un broker) no cambia en nada.
 */
export const OFICIO_AGENTE = 'AGENCY_AGENT_USER';

// `profile` llega con formas distintas según el tipo de usuario (User, AdminUser): se lee con cuidado, no se tipa.
export interface UsuarioConOficio {
  role?: string;
  profile?: unknown;
}

const oficioDe = (user: UsuarioConOficio): unknown =>
  user.profile && typeof user.profile === 'object' ? (user.profile as { oficio?: unknown }).oficio : undefined;

/** `true` solo para un AGENCY_ADMIN cuyo `profile.oficio` es exactamente el de agente. */
export const esDuenoAgente = (user?: UsuarioConOficio | null): boolean =>
  !!user && user.role === 'AGENCY_ADMIN' && oficioDe(user) === OFICIO_AGENTE;

/** Roles que el usuario puede ejercer: su rol y, si es dueño-agente, también el de agente. */
export const rolesEfectivos = (user?: UsuarioConOficio | null): string[] => {
  if (!user?.role) return [];
  return esDuenoAgente(user) ? [user.role, OFICIO_AGENTE] : [user.role];
};

/** ¿Alguno de `roles` está entre los efectivos del usuario? */
export const tieneAlgunRol = (user: UsuarioConOficio | null | undefined, roles: readonly string[]): boolean => {
  const efectivos = rolesEfectivos(user);
  return roles.some((r) => efectivos.includes(r));
};

/** Inicio del dueño-agente; para el resto devuelve `null` y manda la ruta por rol de siempre. */
export const RUTA_INICIO_DUENO_AGENTE = '/agente/dashboard';
export const rutaDeInicioDuenoAgente = (user?: UsuarioConOficio | null): string | null =>
  esDuenoAgente(user) ? RUTA_INICIO_DUENO_AGENTE : null;
